<template>
	
	<article class="affiliate-tile columns is-gapless">
		<div class="column is-narrow">
			<avatar-or-initials :correspondent="affiliate" width="120px" font-size="2rem"></avatar-or-initials>
		</div>
		<div class="column">
			<div class="name">{{affiliate.name}}</div>
			<div class="profession">{{affiliate.profession}}</div>
			<div class="links">
				<a class="button is-black" :href="affiliate.dispensaryUrl">Shop Storefront</a>
				<a :href="affiliate.aboutPageUrl" v-if="affiliate.aboutPageUrl">About {{affiliate.firstName}}</a>
			</div>
			<p class="caption" v-if="affiliate.caption">{{affiliate.caption}}</p>
		</div>
		<div class="column is-narrow">
			<five-image-panel :images="affiliate.imageUrls" background-color="#FBFBFB"></five-image-panel>
		</div>
	</article>
	
</template>
	
<script>
import AvatarOrInitials from "~/pages/account/sessions/AvatarOrInitials.vue";
import FiveImagePanel from "~/components/global/FiveImagePanel.vue";

export default {
	name: "AffiliateTile",
	components: { AvatarOrInitials, FiveImagePanel },
	props: ["affiliate"],
}
</script>

<style lang="scss" scoped>
	
</style>